/**
 * The mark a side wears — on its ring segment and beside its name.
 *
 * Five line emblems, one per 1-5 slot, drawn on a 24-unit square so the same
 * path serves a 5px glyph inside the ring and a 14px mark in the side's text.
 * Slot-fixed like every other side identity: a side wears one sign for the
 * whole fight and wears it identically wherever it is drawn.
 *
 * The first two are not arbitrary. A fight opens with exactly two sides and
 * `apps/fight/constants.py` fixes what they are — slot 1 attacked, slot 2 was
 * attacked — so slot 1 carries the sword and slot 2 the shield. Reading the
 * pair the other way round is reading the fight backwards.
 *
 * They carry the identity that colour used to. The establishment screen paints
 * areas the size of a quarter of the display, and five hues across areas that
 * large read as HUD chrome pasted over the scene rather than as a fight — so
 * the screen is steel throughout and the ember is spent only on the side being
 * read or taken. The emblem is what tells the sides apart.
 */

const EMBLEMS = [
  /* 1 — sword. Slot 1 is the side that started the fight (`ATTACKER_SIDE_NAME`),
     so it wears the mark of striking, not of holding. */
  'M12 1.8l2.4 4.1v9.3h-4.8V5.9ZM7 15.2h10M12 15.2V22.2M9.6 19h4.8',
  /* 2 — shield. Slot 2 is the side that was standing there
     (`DEFENDER_SIDE_NAME`). */
  'M12 2.5 20 5.8v6.4c0 4.6-3.3 7.6-8 9.3-4.7-1.7-8-4.7-8-9.3V5.8ZM12 7v9M8.4 10.6h7.2',
  /* 3 — claw. */
  'M6.2 3.4c1.4 4.6 2.2 9 2.4 14.2M12 2.4c.6 4.9.6 9.6 0 15.2M17.8 3.4c-1.4 4.6-2.2 9-2.4 14.2M4.6 19.4c2.6 2.4 12.2 2.4 14.8 0',
  /* 4 — cowl. */
  'M12 2.2c-5.2 2.4-7.4 8.8-6.2 19.6h12.4C19.4 11 17.2 4.6 12 2.2ZM8.6 11.8c1.2 2 5.6 2 6.8 0M12 15.4v6',
  /* 5 — trident. */
  'M12 2.6v19.2M5.6 6v5.2c0 3.4 3 5 6.4 5s6.4-1.6 6.4-5V6M5.6 6 3.8 8.4M18.4 6l1.8 2.4M9.4 21.8h5.2',
];

export function sideEmblemPath(slot) {
  return EMBLEMS[((slot ?? 1) - 1 + EMBLEMS.length) % EMBLEMS.length];
}

/* The fight's own mark, for the reserved wedge at twelve o'clock. Not a side
   and never drawn like one: a place, not a party to what happens in it. */
export const ARENA_EMBLEM_PATH = 'M12 2.6 21.4 12 12 21.4 2.6 12ZM12 7.6 16.4 12 12 16.4 7.6 12Z';
